import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'tf-boolean-display',
  standalone: true,
  template: `<span>{{ label() }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanDisplayComponent {
  readonly value = input<unknown>();

  readonly label = computed<string>(() => {
    const v = this.value();
    if (v == null) return '—';
    return v ? 'Yes' : 'No';
  });
}
